import React from 'react';
import CheckBox from 'components/shared/CheckBox';
import {
  createHandleCheckBoxChange,
  handleDeployCheckBoxChange,
} from 'helpers/CheckBoxHelper';

const TextCheckBox = ({
  text,
  selectionHandlers: {
    selectedTextsForRevision = [],
    setSelectedTextsForRevision = () => {},
    deploymentQueue = [],
    setDeploymentQueue = () => {},
  } = {},
  eligibility: {
    isEligibleForRevision = false,
    isAwaitingDeployment = false,
    availableRevisionNumber = 0,
  } = {},
}) => {
  const { id: textId, keyword, url } = text || {};

  const handleCheckBoxChangeForRevisionOrValidation =
    createHandleCheckBoxChange(
      selectedTextsForRevision,
      setSelectedTextsForRevision
    );

  const getTick = () => {
    if (isEligibleForRevision) {
      return selectedTextsForRevision.includes(textId);
    }
    if (isAwaitingDeployment) {
      return deploymentQueue?.some((item) => item.id === textId);
    }

    return false;
  };

  const getOnCheck = () => {
    if (isEligibleForRevision) {
      return () => handleCheckBoxChangeForRevisionOrValidation(textId);
    }
    if (isAwaitingDeployment) {
      return () =>
        handleDeployCheckBoxChange(textId, keyword, url, setDeploymentQueue);
    }

    return null;
  };

  const shouldRenderCheckBox =
    (isEligibleForRevision && availableRevisionNumber > 1) ||
    isAwaitingDeployment;

  return (
    shouldRenderCheckBox && (
      <CheckBox
        key={textId}
        name={`text-${textId}`}
        tick={getTick()}
        onCheck={getOnCheck()}
      />
    )
  );
};

export default TextCheckBox;
